import {
  ASN_TO_BERGEN_REQUEST,
  ASN_TO_BERGEN_SUCCESS,
  ASN_TO_BERGEN_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";

///Post Bussiness dashboard
export const asnToBergen = (token, values, mergeInseamToSku) => (dispatch) => {
  dispatch({ type: ASN_TO_BERGEN_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}create/asntobergen`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: { return_header_id: values, mergeInseamToSku },
  })
    .then((response) => {
      return dispatch({
        type: ASN_TO_BERGEN_SUCCESS,
        payload: response,
      });
    })
    .catch((error) => {
      return dispatch({
        type: ASN_TO_BERGEN_ERROR,
        payload: [],
      });
    });
};
